import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { openModal } from '@/components/composed/Modal/actions'
import { addModalToWellKnown } from '@/components/composed/Modal/constants'
import { FinancingCallbackModal } from '@/components/composed/modals/FinancingCallbackModal'
import type { IFinancingCallbackModalProps } from '@/components/composed/modals/FinancingCallbackModal/types'
import { pushGtmEventOnClickFinancingCallbackWidget } from '@/logic/metrika/financing/gtmHelpers'
import { getUserGtmInfo } from '@/logic/metrika/helpers'
import type { RootState } from '@/redux/interfaces'
import { useGetContextForCommentField, useIsShowWidget } from './hooks'
import './styles.scss'

addModalToWellKnown({ FinancingCallbackModal })

const mapState = (state: RootState) => ({
  userGtmInfo: getUserGtmInfo()(state),
})

export const FinancingWidgetCallback = () => {
  const dispatch = useDispatch()
  const isShowWidget = useIsShowWidget()
  const contextMessage = useGetContextForCommentField()
  const { userGtmInfo } = useSelector(mapState)

  const openCallbackModal = () =>
    dispatch(
      openModal({
        options: { dialogId: 'FinancingCallbackModal' },
        contentOptions: {
          context: contextMessage,
        } as IFinancingCallbackModalProps['options'],
      }),
    )

  const handleClickOnWidgetButton = () => {
    pushGtmEventOnClickFinancingCallbackWidget(userGtmInfo)
    openCallbackModal()
  }

  if (!isShowWidget) return null

  return (
    <div className="financingWidgetCallback">
      <button type="button" className="financingWidgetCallback__button" onClick={handleClickOnWidgetButton}>
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.3669 30.1929C20.4469 30.1222 15.0055 29.3702 9.30686 23.6729C3.60953 17.9742 2.85886 12.5342 2.78686 10.6129C2.68019 7.6849 4.92286 4.8409 7.51353 3.73023C7.82549 3.59552 8.16713 3.54423 8.5049 3.5814C8.84267 3.61857 9.16498 3.74291 9.44019 3.94223C11.5735 5.4969 13.0455 7.8489 14.3095 9.69823C14.5876 10.1045 14.7065 10.599 14.6436 11.0873C14.5807 11.5756 14.3403 12.0237 13.9682 12.3462L11.3669 14.2782C11.2412 14.369 11.1527 14.5023 11.1179 14.6533C11.0831 14.8044 11.1043 14.963 11.1775 15.0996C11.7669 16.1702 12.8149 17.7649 14.0149 18.9649C15.2149 20.1649 16.8855 21.2822 18.0309 21.9382C18.1745 22.0188 18.3435 22.0414 18.5032 22.0012C18.6629 21.961 18.8012 21.8612 18.8895 21.7222L20.5829 19.1449C20.8942 18.7314 21.3534 18.4543 21.8644 18.3718C22.3754 18.2893 22.8985 18.4077 23.3242 18.7022C25.2002 20.0009 27.3895 21.4476 28.9922 23.4996C29.2077 23.7768 29.3448 24.1068 29.3891 24.4551C29.4334 24.8034 29.3834 25.1572 29.2442 25.4796C28.1282 28.0836 25.3042 30.3009 22.3669 30.1929Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  )
}
